import {Slider, SliderProps} from '@mui/material';
import {MuiSliderEmotionLtrProvider} from './MuiSliderEmotionLtrProvider';

const DEFAULT_RANGE_SX = {
  color: '#0080A6',
  '& .MuiSlider-track': {height: 16, border: 'none'},
  '& .MuiSlider-rail': {height: 16, opacity: 1, backgroundColor: '#E6E0E9'},
  '& .MuiSlider-thumb': {width: 4, height: 44, borderRadius: 2},
  '&.Mui-disabled': {
    color: '#0080A6',
    opacity: 1,
    '& .MuiSlider-track': {
      backgroundColor: '#0080A6',
      border: 'none',
    },
    '& .MuiSlider-rail': {opacity: 1, backgroundColor: '#E6E0E9'},
    '& .MuiSlider-thumb': {backgroundColor: '#0080A6'},
    '& .MuiSlider-valueLabel': {
      backgroundColor: '#0080A6',
      color: '#fff',
      opacity: 1,
    },
  },
  '& .MuiSlider-valueLabel': {
    backgroundColor: '#0080A6',
    color: '#fff',
    fontSize: 12,
    fontWeight: 500,
    padding: '6px 10px',
    borderRadius: '50%',
  },
} as const;

type AppRangeSliderProps = Omit<SliderProps, 'sx'> & {
  /** Content rendered to the left of the slider (start / min side). */
  startLabel?: React.ReactNode;
  /** Content rendered to the right of the slider (end / max side). */
  endLabel?: React.ReactNode;
  /** Extra className applied to the outer wrapper div. */
  containerClassName?: string;
  /** Extra className applied to both label spans. */
  labelClassName?: string;
  /** Merged on top of the default sx. Supports all MUI sx formats. */
  sx?: SliderProps['sx'];
};

function AppRangeSlider({
  startLabel,
  endLabel,
  containerClassName = '',
  labelClassName = 'shrink-0 text-textColor tabular-nums',
  sx,
  size = 'medium',
  valueLabelDisplay = 'on',
  disableSwap = true,
  ...sliderProps
}: AppRangeSliderProps) {
  // Merge default sx with any consumer overrides using MUI's array form.
  const mergedSx = sx
    ? [DEFAULT_RANGE_SX, ...(Array.isArray(sx) ? sx : [sx])]
    : DEFAULT_RANGE_SX;

  return (
    <div dir="ltr" className={`flex items-center gap-3 ${containerClassName}`}>
      {startLabel !== undefined && (
        <span className={labelClassName}>{startLabel}</span>
      )}

      <MuiSliderEmotionLtrProvider>
        <Slider
          size={size}
          valueLabelDisplay={valueLabelDisplay}
          disableSwap={disableSwap}
          {...sliderProps}
          sx={mergedSx}
        />
      </MuiSliderEmotionLtrProvider>

      {endLabel !== undefined && (
        <span className={labelClassName}>{endLabel}</span>
      )}
    </div>
  );
}

export default AppRangeSlider;
